import React from 'react';
import { baseURL } from 'config/api.js';
import { useState, useEffect } from 'react';
import { AuthContext } from '../../context/AuthContext.jsx';
import { useContext } from 'react';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import { CurrencyDollar } from 'assets/svgs/CurrencyDollar.jsx';
import { DiamondSVG } from 'assets/svgs/DiamondSVG.jsx';
import { UserRoundedSVG } from 'assets/svgs/UserRoundedSVG.jsx';

export const MainNumbersCards = () => {
  const [projectsCount, setProjectsCount] = useState(null);
  const [vendorsCount, setVendorsCount] = useState(null);
  const [tasksCount, setTasksCount] = useState(null);
  const [employeesCount, setEmployeesCount] = useState(null);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { userData } = useContext(AuthContext);

  useEffect(() => {

    async function fetchData() {
      let url = baseURL + "/projects?skip=no";
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userData.token
      };
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      const jsonData = await response.json();
      if (!response.ok) {
        toast.error(jsonData.data.message);
        setIsLoadingError(true);
        setIsLoading(false);
        return; //early return
      }
      const projectsCount = jsonData.data.docsCount;

      let getVendorsURL = baseURL + "/vendors?skip=no";
      const getVendorsResponse = await fetch(getVendorsURL, {
        method: "GET",
        headers: headers
      });
      const getVendorsJSONData = await getVendorsResponse.json();
      if (!getVendorsResponse.ok) {
        toast.error(getVendorsJSONData.data.message);
        setIsLoadingError(true);
        setIsLoading(false);
        return; //early return
      }

      let getTasksURL = baseURL + "/employeestasks?skip=no";
      const getTasksResponse = await fetch(getTasksURL, {
        method: "GET",
        headers: headers
      });
      const getTasksJSONData = await getTasksResponse.json();
      if (!getTasksResponse.ok) {
        toast.error(getTasksJSONData.data.message);
        setIsLoadingError(true);
        setIsLoading(false);
        return; //early return
      }

      let getEmployeesURL = baseURL + "/employees";
      const getEmployeesResponse = await fetch(getEmployeesURL, {
        method: "GET",
        headers: headers
      });
      const getEmployeesJSONData = await getEmployeesResponse.json();
      if (!getEmployeesResponse.ok) {
        toast.error(getEmployeesJSONData.data.message);
        setIsLoadingError(true);
        setIsLoading(false);
        return; //early return
      }

      setProjectsCount(projectsCount);
      setVendorsCount(getVendorsJSONData.data.docsCount);
      setTasksCount(getTasksJSONData.data.docsCount);
      setEmployeesCount(getEmployeesJSONData.data.docsCount);
      setIsLoading(false);
    }

    fetchData().catch(e => {
      setIsLoading(false);
      toast.error("An error occurred while communicating with the server.");
    });

  }, []);

  console.log("Before MainNumbersCards() rendering");

  return (
    <div className='flex flex-row flex-wrap gap-y-4 justify-between'>

      <div className='w-1/2 xl:w-1/4'>

        <div className='flex flex-row gap-x-4 p-4 me-4 bg-white rounded-md shadow-md'>
          <div className='w-9 h-9 md:w-16 md:h-16 xl:w-12 xl:h-12 rounded-full bg-primary text-white flex justify-center items-center'>
            <svg version="1.1"
              width="1.5rem"
              height="1.5rem"
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M23.7773 13.6557C23.777 13.6252 23.773 13.5946 23.7653 13.5644C23.7643 13.5607 23.7633 13.5572 23.7622 13.5535C23.759 13.5424 23.7552 13.5314 23.7509 13.5204C23.7494 13.5165 23.748 13.5127 23.7464 13.5088C23.7411 13.4967 23.7353 13.4847 23.7287 13.4729C23.7278 13.4713 23.7271 13.4695 23.7261 13.4679C23.7179 13.4537 23.7096 13.4416 23.7009 13.4299C23.6988 13.4271 23.6966 13.4245 23.6944 13.4219C23.6869 13.4123 23.679 13.4032 23.6706 13.3945C23.6679 13.3917 23.6652 13.3889 23.6624 13.3862C23.653 13.3769 23.6432 13.3682 23.6329 13.3601C23.6312 13.3587 23.6296 13.3572 23.6279 13.3559C23.6155 13.3464 23.6026 13.3377 23.5893 13.3299C23.5873 13.3285 18.0801 10.1201 18.0801 10.1201V3.70209C18.0801 3.70076 18.0799 3.69954 18.0799 3.69821C18.0795 3.66772 18.0756 3.63714 18.0679 3.60696C18.0669 3.60328 18.0658 3.59971 18.0647 3.59608C18.0615 3.58495 18.0577 3.57392 18.0535 3.56294C18.052 3.55906 18.0505 3.55523 18.0489 3.5514C18.0437 3.53925 18.0378 3.5273 18.0312 3.5155C18.0303 3.51387 18.0296 3.51208 18.0286 3.51045C18.0205 3.49625 18.0121 3.4841 18.0034 3.47235C18.0014 3.4697 17.9992 3.4672 17.9971 3.46459C17.9895 3.45489 17.9815 3.44565 17.9731 3.43692C17.9705 3.43421 17.9679 3.43155 17.9652 3.42895C17.9556 3.4195 17.9456 3.41057 17.9351 3.40229C17.9336 3.40112 17.9322 3.39979 17.9307 3.39867C17.9182 3.38902 17.9052 3.38029 17.8917 3.37232C17.89 3.3712 12.1926 0.0520468 12.1926 0.0520468C12.0734 -0.0173489 11.9262 -0.0173489 11.807 0.0520468L6.10967 3.3712C6.09451 3.38029 6.08139 3.38912 6.06877 3.39877C6.06739 3.39984 6.06612 3.40102 6.06474 3.40214C6.05417 3.41052 6.04406 3.4195 6.03436 3.42905C6.0317 3.43166 6.02915 3.43426 6.02654 3.43697C6.01812 3.44575 6.0101 3.45504 6.00244 3.46474C6.0004 3.46735 5.9982 3.4698 5.99621 3.47246C5.98743 3.4842 5.9791 3.49635 5.97155 3.50932C5.96996 3.51218 5.96925 3.51392 5.96833 3.5156C5.96174 3.5274 5.95587 3.53935 5.95066 3.5515C5.94903 3.55528 5.9476 3.55916 5.94612 3.56304C5.94183 3.57397 5.93805 3.585 5.93483 3.59618C5.93376 3.59981 5.93269 3.60338 5.93177 3.60706C5.92401 3.63724 5.92002 3.66783 5.91977 3.69831C5.91977 3.69959 5.91951 3.70086 5.91951 3.70219V10.1204L0.41233 13.3286C0.397011 13.3378 0.384091 13.3465 0.371683 13.3561C0.369998 13.3574 0.368415 13.3588 0.36673 13.3601C0.356466 13.3683 0.346662 13.3771 0.337215 13.3863C0.334457 13.389 0.3317 13.3918 0.329045 13.3946C0.320721 13.4032 0.312806 13.4124 0.305249 13.4219C0.303104 13.4246 0.300857 13.4272 0.298815 13.43C0.290083 13.4416 0.281759 13.4538 0.274202 13.4667C0.272619 13.4696 0.271904 13.4713 0.270985 13.473C0.264398 13.4848 0.258525 13.4967 0.253317 13.5089C0.251683 13.5127 0.250253 13.5166 0.248772 13.5204C0.244483 13.5314 0.240704 13.5424 0.237487 13.5536C0.236415 13.5572 0.235342 13.5608 0.234423 13.5645C0.226662 13.5946 0.222679 13.6252 0.222423 13.6557C0.222423 13.657 0.222168 13.6583 0.222168 13.6596V20.2979C0.222168 20.4342 0.294628 20.5602 0.412381 20.6288L6.10973 23.9479C6.1108 23.9485 6.11197 23.9489 6.11305 23.9496C6.12673 23.9574 6.14087 23.9645 6.15558 23.9707C6.16988 23.9766 6.18428 23.9813 6.19899 23.9854C6.20261 23.9864 6.20629 23.9873 6.20996 23.9882C6.22145 23.9911 6.23315 23.9934 6.24504 23.9952C6.24898 23.9958 6.25281 23.9965 6.25674 23.997C6.2718 23.9987 6.28702 24 6.30254 24C6.31807 24 6.33333 23.9988 6.34835 23.997C6.35228 23.9965 6.35611 23.9958 6.36004 23.9952C6.37194 23.9934 6.38363 23.9911 6.39512 23.9882C6.3988 23.9873 6.40247 23.9864 6.4061 23.9854C6.42081 23.9813 6.43521 23.9766 6.44915 23.9708C6.46416 23.9646 6.4783 23.9574 6.49199 23.9496C6.49306 23.9489 6.49424 23.9485 6.49531 23.9479L11.9998 20.7411L17.5044 23.9479C17.5055 23.9485 17.5067 23.9489 17.5077 23.9496C17.5214 23.9574 17.5355 23.9645 17.5502 23.9707C17.5646 23.9766 17.5789 23.9813 17.5936 23.9854C17.5972 23.9864 17.6009 23.9873 17.6046 23.9883C17.6161 23.9911 17.6277 23.9934 17.6396 23.9952C17.6436 23.9958 17.6474 23.9965 17.6514 23.997C17.6664 23.9988 17.6817 24 17.6972 24C17.7127 24 17.7279 23.9988 17.743 23.997C17.7469 23.9965 17.7508 23.9958 17.7547 23.9952C17.7666 23.9934 17.7783 23.9911 17.7898 23.9883C17.7934 23.9873 17.7971 23.9865 17.8008 23.9854C17.8154 23.9813 17.8298 23.9766 17.8437 23.9708C17.8588 23.9645 17.8729 23.9574 17.8866 23.9496C17.8877 23.9489 17.8889 23.9485 17.8899 23.9479L23.5873 20.6288C23.705 20.5601 23.7775 20.4341 23.7775 20.2979V13.6596C23.7775 13.6582 23.7773 13.657 23.7773 13.6557ZM22.6337 13.6595L17.6972 16.5355L12.7606 13.6595L17.6972 10.7836L22.6337 13.6595ZM6.68547 4.36842L11.6169 7.24132V12.9932L6.68547 10.1203V4.36842ZM17.3142 10.1203L12.3828 12.9932V7.24137L17.3142 4.36847V10.1203ZM11.6169 20.0777L6.68547 22.9507V17.1988L11.6169 14.3259V20.0777ZM12.3828 14.3259L17.3142 17.1988V22.9506L12.3828 20.0777V14.3259ZM11.9998 0.826175L16.9364 3.70209L11.9998 6.578L7.06329 3.70209L11.9998 0.826175ZM6.30249 10.7836L11.239 13.6595L6.30249 16.5355L1.36595 13.6595L6.30249 10.7836ZM0.988125 14.3259L5.91951 17.1988V22.9506L0.988125 20.0776V14.3259ZM18.0802 22.9507V17.1988L23.0115 14.3259V20.0777L18.0802 22.9507Z" fill="currentColor" />
            </svg>
          </div>

          <div className='flex flex-col justify-around'>

            <div>
              {
                projectsCount === null ? <ClipLoader size={11} color="#000" /> : (
                  projectsCount
                )
              }
            </div>

            <div>Projects</div>

          </div>
        </div>

      </div>

      <div className='w-1/2 xl:w-1/4'>

        <div className='flex flex-row gap-x-4 p-4 xl:me-4 bg-white rounded-md shadow-md'>

          <div className='w-9 h-9 md:w-16 md:h-16 xl:w-12 xl:h-12 rounded-full bg-primary text-white flex justify-center items-center'>
              <CurrencyDollar />
          </div>

          <div className='flex flex-col justify-around'>

            <div>
              {
                vendorsCount === null ? <ClipLoader size={11} color="#000" /> : (
                  vendorsCount
                )
              }
            </div>

            <div>Vendors</div>

          </div>

        </div>

      </div>

      <div className='w-1/2 xl:w-1/4'>

        <div className='flex flex-row gap-x-4 p-4 me-4 bg-white rounded-md shadow-md'>

          <div className='w-9 h-9 md:w-16 md:h-16 xl:w-12 xl:h-12 rounded-full bg-primary text-white flex justify-center items-center'>
            <DiamondSVG />

          </div>

          <div className='flex flex-col justify-around'>

            <div>
              {
                tasksCount === null ? <ClipLoader size={11} color="#000" /> : (
                  tasksCount
                )
              }
            </div>

            <div>Tasks</div>

          </div>

        </div>

      </div>

      <div className='w-1/2 xl:w-1/4'>

        <div className='flex flex-row gap-x-4 p-4 bg-white rounded-md shadow-md'>

          <div className='w-9 h-9 md:w-16 md:h-16 xl:w-12 xl:h-12 rounded-full bg-primary text-white flex justify-center items-center'>
            <UserRoundedSVG />
          </div>

          <div className='flex flex-col justify-around'>

            <div>
              {
                employeesCount === null ? <ClipLoader size={11} color="#000" /> : (
                  employeesCount
                )
              }
            </div>

            <div>Employees</div>

          </div>

        </div>

      </div>

    </div>
  );
}
